import React from "react";
import { useQuery, useSubscription } from "@apollo/react-hooks";
import { NavLink } from "react-router-dom";
import { SEARCH_CHATS } from "graphql/query/chat-gql";
import { GET_ME } from "graphql/query/user-gql";
import { CHAT_MESSAGE_CREATED_SUBSCRIPTION, CHAT_MESSAGE_UPDATED_SUBSCRIPTION } from "graphql/subscription/chat-gql";
import Icons from "components/icons";
import { Localize } from "components/service";

const ChatUnreadIndicatorButton = () => {
    const { data, client, refetch } = useQuery(SEARCH_CHATS, {
        variables: { filter: "" },
        fetchPolicy: "cache-and-network",
        notifyOnNetworkStatusChange: true
    });
    const { me } = client.readQuery({ query: GET_ME });

    useSubscription(CHAT_MESSAGE_CREATED_SUBSCRIPTION, {
        onSubscriptionData: (payload) => {
            refetch();
        }
    });
    useSubscription(CHAT_MESSAGE_UPDATED_SUBSCRIPTION, {
        onSubscriptionData: (payload) => {
            refetch();
        }
    });

    let hasUnread = false;
    if (data && data.chatSearch && data.chatSearch.edges)
    {
        for (const { node: chat } of data.chatSearch.edges)
        {
            const messages = chat.messages?.edges || [];
            const message = messages[ 0 ]?.node;
            if (
                message &&
                me.id !== message.author_id &&
                message.status === "send"
            )
            {
                hasUnread = true;
                break;
            }
        }
    }

    return (
        <NavLink
            to="/chat"
            title={ Localize({children: "MENUS.Label_Chat" }).props.children }
            className="header-action-chat"
            exact
            style={{ position: "relative" }}
        >
            {hasUnread && <span className="notification-badge company-bg-color" />}
            <Icons.Chat type="menu" />
        </NavLink>
    );
};

export default ChatUnreadIndicatorButton;